module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "calendar"
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "fullscreen": ""
    },
    model: {
      value: (_vm.settingsDialog),
      callback: function($$v) {
        _vm.settingsDialog = $$v
      },
      expression: "settingsDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-subheader', [_vm._v("Settings")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.settingsDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-container', {
    staticClass: "calendar-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('request-status', {
    attrs: {
      "request": _vm.appointmentsRequest,
      "message200": false
    }
  }), _vm._v(" "), _c('v-system-bar', {
    attrs: {
      "flat": "",
      "dark": ""
    }
  }, [_c('v-icon', {
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("replay")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.doShowCalendar(true, "date")
      }
    }
  }, [_vm._v(_vm._s(_vm.naturalday(_vm.selectedDate)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('calendar-settings', {
    model: {
      value: (_vm.settings),
      callback: function($$v) {
        _vm.settings = $$v
      },
      expression: "settings"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.doShowCalendar(true, "date")
      }
    }
  }, [_c('v-icon', [_vm._v("event")])], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "350"
    },
    model: {
      value: (_vm.showCalendar),
      callback: function($$v) {
        _vm.showCalendar = $$v
      },
      expression: "showCalendar"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-date-picker', {
    staticClass: "elevation-0",
    attrs: {
      "type": _vm.datePickerType,
      "full-width": ""
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "small": "",
      "flat": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.doShowCalendar(false)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "overline",
    on: {
      "click": _vm.gotoToday
    }
  }, [_vm._v("Today is " + _vm._s(_vm.dateformat(_vm.now, 'ddd D MMM YY')))])], 1), _vm._v(" "), (_vm.infoTeamCount > 1) ? _c('calendar-tabs', {
    attrs: {
      "dark": "",
      "facets": _vm.facets
    },
    on: {
      "space": _vm.setSelectedSpace
    },
    model: {
      value: (_vm.practitioner),
      callback: function($$v) {
        _vm.practitioner = $$v
      },
      expression: "practitioner"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card', {
    staticClass: "solid py-1 hidden-xs-only",
    attrs: {
      "flat": ""
    }
  }, [_c('div', {
    staticClass: "horizontal-scrolling-wrapper week",
    attrs: {
      "id": "week-view"
    }
  }, _vm._l((_vm.monthDates), function(day) {
    return _c('div', {
      key: day,
      staticClass: "day",
      class: {
        'blue lighten-2': _vm.isActive(day),
        'yellow lighten-5': _vm.isToday(day),
        'blue lighten-4 black--text': _vm.isVisible(day),
        'grey--text': !_vm.isVisible(day)
      },
      on: {
        "click": function($event) {
          _vm.selectedDate = day
        }
      }
    }, [_c('div', {
      staticClass: "dow overline",
      class: "dow-" + _vm.dateformat(day, "ddd").toLowerCase()
    }, [_vm._v(_vm._s(_vm.dateformat(day, 'ddd')))]), _vm._v(" "), _c('div', {
      staticClass: "date black--text"
    }, [_vm._v(_vm._s(_vm.dateformat(day, 'D')))])])
  }), 0)]), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "touch",
      rawName: "v-touch",
      value: ({
        left: function () {
          _vm.dateMath(1, 'days')
        },
        right: function () {
          _vm.dateMath(-1, 'days')
        }
      }),
      expression: "{left: () => { dateMath(1, 'days') }, right: () => { dateMath(-1, 'days') }}"
    }],
    staticClass: "px-1",
    attrs: {
      "row": ""
    }
  }, _vm._l((_vm.daysToShow), function(day) {
    return _c('v-flex', {
      key: day,
      staticClass: "pa-0",
      class: {
        weekviewactive: _vm.isActive(day)
      },
      attrs: {
        "xs12": "",
        "sm3": ""
      }
    }, [_c('v-subheader', {
      staticClass: "hidden-xs-only overline pl-1 grey lighten-4 justify-center",
      class: {
        'grey lighten-2': _vm.isActive(day),
        'grey lighten-4': !_vm.isActive(day)
      },
      staticStyle: {
        "height": "24px",
        "border-right": "solid 1px #DDD"
      }
    }, [_vm._v("\n              " + _vm._s(_vm.dateformat(day, 'ddd D MMM')) + "\n            ")]), _vm._v(" "), (_vm.practitioner) ? _c('practitioner-day-view', {
      class: {
        'elevation-5': _vm.isActive(day)
      },
      staticStyle: {
        "border-right": "solid 1px #ccc"
      },
      attrs: {
        "practitioner": _vm.practitioner,
        "with-fetch": false,
        "withWeek": _vm.$vuetify.breakpoint.xs,
        "withAdd": _vm.$vuetify.breakpoint.xs,
        "settings": _vm.settings,
        "date": day
      },
      on: {
        "dayview:createevent": _vm.slotSelected,
        "dayview:delete": _vm.deleteEvent,
        "dayview:save": _vm.showQuickCreate,
        "dayview:eventclicked": _vm.eventClicked,
        "dayview:multiselect": _vm.setMultiSelect,
        "update:date": _vm.setDate,
        "facets": _vm.setFacets
      }
    }) : _vm._e()], 1)
  }), 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd0ec28","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Calendar.vue
// module id = 1458
// module chunks = 9